import React from "react";

export default function Add() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none">
      <g clipPath="url(#clip0_3_5938)">
        <path d="M19.2256 9.663H14.1631V5.24137C14.1631 4.6988 13.6593 4.25879 13.0381 4.25879H11.9131C11.2919 4.25879 10.7881 4.6988 10.7881 5.24137V9.663H5.72559C5.10438 9.663 4.60059 10.103 4.60059 10.6456V11.6282C4.60059 12.1707 5.10438 12.6107 5.72559 12.6107H10.7881V17.0324C10.7881 17.5749 11.2919 18.015 11.9131 18.015H13.0381C13.6593 18.015 14.1631 17.5749 14.1631 17.0324V12.6107H19.2256C19.8468 12.6107 20.3506 12.1707 20.3506 11.6282V10.6456C20.3506 10.103 19.8468 9.663 19.2256 9.663Z" fill="#B8BAC2" />
      </g>
      <defs>
        <clipPath id="clip0_3_5938">
          <rect width="15.75" height="15.7213" fill="white" transform="translate(4.60059 3.27637)" />
        </clipPath>
      </defs>
    </svg>
  );
}
